

export const tutorialContent = [
    `
<h1>Welcome to Pathfinding Visualizer</h1>
            <h3>This short tutorial will walk you through all of the features of this application.</h2>
                <p>If you want to dive right in, feel free to press the "Skip Tutorial" button below. Otherwise, press
                    "Next"!
                </p>

`,
    `
<h1>What is a Pathfinding Algorithm?</h1>
<h3>At its core, a pathfinding algorithm seeks to find the shortest path between two points. This application visualizes various pathfinding algorithms in action, and more!</h3>
<p>All of the algorithms on this application are adapted for a 2D grid, where 90 degree turns have a "cost" of 1.5 and movements from a node to another have a "cost" of 1.</p>
`
];
